module.exports = __webpack_public_path__ + "static/img/science_technology_intensity_4.2ac1427.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/science_technology_intensity_4.png
// module id = rKKo
// module chunks = 6